<template>
    <div>
        <!--  <DialogoConfirmar ref="dialogConfirmar" :msgAceptar="aceptar" :msgCancelar="cancelar" :msg="mensaje" /> -->
        <v-card flat>
            <ValidationObserver ref="obs" v-slot="{ invalid, state }">
                <v-form name="formEditarDatosProf" @submit.prevent="guardar">
                    <v-row class="mx-1">
                        <v-col :class="($vuetify.breakpoint.mobile) ? 'my-2' : 'my-5'">
                            <div class="font-weight-bold text-body-1 black--text text-uppercase">
                                Datos profesionales
                            </div>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-text-field dense v-model="matricula" @keydown="preventArrowKeys" hide-spin-buttons
                                readonly label="Nº matrícula">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider ref="provFectit" rules="required" v-slot="{ errors }">
                                <v-text-field v-model="fectitFormatted" dense readonly
                                    append-icon="mdi-calendar" @click="menuFectit = true"
                                    @click:append="menuFectit = true" :error-messages="errors"
                                    @blur="validateDate">
                                    <template v-slot:label>
                                        Fecha de expedición de título:
                                        <v-tooltip top color="orange darken-2">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon small v-bind="attrs" v-on="on"
                                                    class="ml-1 mb-1">mdi-information</v-icon>
                                            </template>
                                            <span>NO la fecha de finalización de la carrera</span>
                                        </v-tooltip>
                                    </template>
                                </v-text-field>
                                <v-dialog v-model="menuFectit" width="290px">
                                    <v-date-picker v-model="dataSelected.fectit" no-title locale="es-AR"
                                        :max="hoyISO" scrollable @input="onPickFectit"></v-date-picker>
                                </v-dialog>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider ref="provFecmat" :rules="{
                                required: true, rangoFechas: {
                                    fechaDada: dataSelected.fectit,
                                }
                            }" v-slot="{ errors, dirty }">
                                <v-text-field v-model="fecmatFormatted" dense readonly
                                    label="Fecha de matriculación:" append-icon="mdi-calendar"
                                    @click="menuFecmat = true" @click:append="menuFecmat = true"
                                    :error-messages="errors" @blur="validateDate"></v-text-field>
                                <v-dialog v-model="menuFecmat" width="290px">
                                    <v-date-picker v-model="dataSelected.fecmat" no-title locale="es-AR"
                                        :max="hoyISO" scrollable @input="onPickFecmat"></v-date-picker>
                                </v-dialog>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10" v-slot="{ errors, dirty }">
                                <v-text-field dense v-model="dataSelected.tomo"
                                    @input="dataSelected.tomo = dataSelected.tomo.toUpperCase()" hide-spin-buttons
                                    label="Tomo" :error-messages="errors">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10" v-slot="{ errors, dirty }">
                                <v-text-field name="Folio"
                                    @input="dataSelected.folio = dataSelected.folio.toUpperCase()" dense
                                    v-model="dataSelected.folio" hide-spin-buttons label="Folio"
                                    :error-messages="errors">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-slide-y-transition>
                            <v-col cols="12" md="12" v-if="necesitaHistorial">
                                <v-alert type="warning" dense icon="mdi-alert" class="rounded-0"
                                    color="orange darken-2">
                                    Deberá adjuntar historial de matrícula expedido por el colegio de psicológos.
                                </v-alert>
                            </v-col>
                        </v-slide-y-transition>
                    </v-row>
                    <v-divider class="ma-5"></v-divider>
                    <v-row class="mx-1">
                        <v-col class='my-2'>
                            <div class="font-weight-bold text-body-1 black--text text-uppercase">
                                Documentación requerida:
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-space-around align-end mb-2">
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="titFrenteAfiliado"
                            label="TÍTULO FRENTE" />
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="titDorsoAfiliado"
                            label="TÍTULO DORSO" />
                        <InputButtonArchivo v-if="!esAnterior" @fileSelected="handleFileSelected" op="certMatricula"
                            label="CERT. MATRÍCULA" />
                        <InputButtonArchivo v-if="necesitaHistorial" @fileSelected="handleFileSelected"
                            op="histMatricula" label="HIST. MATRÍCULA" />
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <div class="d-flex justify-space-between form-footer" @click="forzarValidacion">
                        <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <!-- :disabled="invalid || !formValid" -->
                        <v-btn color="primary" elevation="0" :disabled="invalid || !formValid" type="submit"
                            class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import InputFechaModal from '@/components/inputs/InputFechaModal.vue';
import InputButtonTitulo from '@/components/inputs/InputButtonTitulo.vue';
import InputButtonTituloDorso from '@/components/inputs/InputButtonTituloDorso.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import InputArchGen from '@/components/inputs/InputArchGen.vue';

export default {
    components: {
        InputFechaModal,
        InputButtonTitulo,
        InputButtonTituloDorso,
        InputButtonArchivo,
        InputArchGen,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            nroafi: '',
            dataSelected: {
                tomo: '',
                folio: '',
                fectit: '',
                fecmat: '',
            },
            files: [],
            op: 'profesionales',
            tituloValido: false,
            formValid: false,
            hayHistorial: false,
            menuFectit: false,
            menuFecmat: false,
            //altaMatricular: false
        }
    },
    mounted() {
        this.nroafi = this.matricula
        if (this.nroafi == '') {
            this.showSnack({
                message: 'Ocurrio un error',
                type: '400'
            })
            this.$router.push('/preafiliacion').catch(() => { })
        }
    },
    computed: {
        //preafiliacion
        ...mapGetters('preafiliacion', ['fecnacim', 'matricula', 'itemNivel', 'archProfesionales2', 'titDorsoAfiliado', 'titFrenteAfiliado', 'histMatricula', 'certMatricula', 'datosPersonales', 'necesitaHistorial']),
        // Fecha maxima seleccionable (hoy): las fechas de titulo/matricula no pueden ser futuras
        hoyISO() {
            return new Date().toISOString().slice(0, 10);
        },
        // Muestran la fecha SIEMPRE como dd/mm/yyyy, sin depender del formato regional del navegador/SO.
        // El valor real (dataSelected.*) sigue siendo ISO yyyy-mm-dd; el campo es de solo lectura y
        // la fecha se elige por el calendario, por lo que el setter no se usa.
        fectitFormatted: {
            get() { return this.formatFecha(this.dataSelected.fectit); },
            set() { },
        },
        fecmatFormatted: {
            get() { return this.formatFecha(this.dataSelected.fecmat); },
            set() { },
        },
        esAnterior() {
            if (this.dataSelected.fecmat !== "") {
                let [y, m, d] = this.dataSelected.fecmat.split('-')
                if (y < "2020") return true
                else return false
            }
        },
        /*         necesitaHistorial() {
                    const today = (new Date()).toJSON().slice(0, 10)
                    return ((this.countWorkDay(this.dataSelected.fecmat, today) > 34) ? true : false)
                }, */
        necesitaArchivos() {
            return (this.hayHistorial)
        },
        mdCalculado() {
            if (!this.necesitaArchivos) return '4'
            else return '3'
        },
        fechasCompletas() {
            return (this.dataSelected.fecmat !== '' && this.dataSelected.fectit !== '')
        },

    },
    watch: {
        'necesitaArchivos'(newValue) {
            if (!newValue) {
                this.addFilesPre({ op: 'histMatricula', file: '' })
            }
        }
    },
    methods: {

        ...mapActions('preafiliacion', ['getOpcionNivel', 'getReducido', 'addFilesPre', 'deleteFiles', 'guardarFechaAfi', 'guardarFechaTitulo', 'guardarFechaMatricula', 'addItemNivel', 'guardarDatosProfesionales', 'getValidarFechaMatricula']),
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),

        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        handleFileSelected() {
            const hasTitFrente = Array.isArray(this.titFrenteAfiliado) ? this.titFrenteAfiliado.length > 0 : !!this.titFrenteAfiliado;
            const hasTitDorso = Array.isArray(this.titDorsoAfiliado) ? this.titDorsoAfiliado.length > 0 : !!this.titDorsoAfiliado;
            const hasCertMat = Array.isArray(this.certMatricula) ? this.certMatricula.length > 0 : !!this.certMatricula;
            const hasHist = Array.isArray(this.histMatricula) ? this.histMatricula.length > 0 : !!this.histMatricula;

            if (this.esAnterior) {
                // esAnterior && necesitaHistorial -> requiere historial
                // esAnterior && !necesitaHistorial -> solo título frente/dorso
                this.formValid = this.necesitaHistorial
                    ? (hasTitFrente && hasTitDorso && hasHist)
                    : (hasTitFrente && hasTitDorso);
            } else {
                // !esAnterior && necesitaHistorial -> requiere cert. matrícula + historial
                // !esAnterior && !necesitaHistorial -> requiere cert. matrícula
                this.formValid = this.necesitaHistorial
                    ? (hasTitFrente && hasTitDorso && hasCertMat && hasHist)
                    : (hasTitFrente && hasTitDorso && hasCertMat);
            }
        },

        validarFecmat() {
            this.getValidarFechaMatricula(this.dataSelected.fecmat)
        },
        // ISO 'yyyy-mm-dd' -> 'dd/mm/yyyy' (formato fijo, independiente del SO/navegador)
        formatFecha(iso) {
            if (!iso) return '';
            const [y, m, d] = iso.split('-');
            return `${d}/${m}/${y}`;
        },
        // Campo readonly: no dispara el evento 'input', asi que sincronizamos el valor
        // al provider y lo validamos a mano (no confiar en el valor interno de vee-validate).
        revalidarProvider(refName, valor) {
            const p = this.$refs[refName];
            if (!p) return;
            if (typeof p.syncValue === 'function') p.syncValue(valor);
            p.validate(valor);
        },
        onPickFectit() {
            this.menuFectit = false;
            this.$nextTick(() => {
                this.revalidarProvider('provFectit', this.fectitFormatted);
                // La matriculacion depende del titulo: re-validar si ya tiene valor
                if (this.dataSelected.fecmat) this.revalidarProvider('provFecmat', this.fecmatFormatted);
            });
        },
        onPickFecmat() {
            this.menuFecmat = false;
            this.validarFecmat();
            this.$nextTick(() => {
                this.revalidarProvider('provFecmat', this.fecmatFormatted);
            });
        },

        validateDate() {
            if (this.esMayor(this.dataSelected.fectit, this.dataSelected.fecmat) && (this.fechasCompletas)) {
                this.showSnack({
                    message: 'La fecha de matriculación debe ser posterior a la fecha de titulacíon',
                    type: '400'
                })
            }
        },
        calcularEdad(fecha) {
            // retorna la edad 
            const anioNacim = this.fecnacim.split('-')[0]
            const anioCalc = fecha.split('-')[0]
            let edad = anioCalc - anioNacim
            return edad
        },
        volver() {
            this.$emit('atras')
        },
        /* 
        Funciones Adi
        */
        stringToDate(dateString) {
            dateString = dateString.split('-');
            return new Date(dateString[0], dateString[1], dateString[2]);
        },

        countWorkDay(sDay, eDay) {
            var s = this.stringToDate(sDay), e = this.stringToDate(eDay);
            var s_t_w = s.getDay(), e_t_w = e.getDay();
            // Diferencia en días
            var diffDay = (e - s) / (1000 * 60 * 60 * 24) + 1;
            var diffWeekDay = diffDay - (s_t_w == 0 ? 0 : 7 - s_t_w) + e_t_w;
            // El cálculo tiene varias semanas completas
            var weeks = Math.floor(diffWeekDay / 7);
            if (weeks <= 0) {// En la misma semana, es decir, la hora de inicio y finalización no puede ser el domingo y el sábado (el domingo es el primer día de la semana)
                return e_t_w - s_t_w + (s_t_w ? 1 : 0) + (e_t_w == 6 ? -1 : 0);
            } else {
                return weeks * 5 + (e_t_w == 6 ? 5 : e_t_w) + (s_t_w >= 1 && s_t_w <= 5 ? (6 - s_t_w) : 0);
            }
        },

        // devuelve cantidad de años que pasaron desde $fecha
        // recibida por parametro, cuanta como primer año $fecha
        calcularAniosDesde(fecha) {
            const anioActual = (this.fecafil).split('-', 1)
            const y = fecha.split('-', 1)
            return anioActual - (y - 1)
        },

        onClearFileInput() {
            console.log('clear formEditarDatosProf')
            this.deleteFiles({ file: '', op: 'profesionales' })
        },

        // si fecha1 >= fecha2 true
        // sino false
        esMayor(fecha1, fecha2) {
            const [anioUno, mesUno, diaUno] = fecha1.split('-')
            const [anioDos, mesDos, diaDos] = fecha2.split('-')
            if (parseInt(anioUno) > parseInt(anioDos)) {
                return true;
            } else if (parseInt(anioUno) < parseInt(anioDos)) {
                return false;
            }
            if (parseInt(mesUno) > parseInt(mesDos)) {
                return true;
            } else if (parseInt(mesUno) < parseInt(mesDos)) {
                return false;
            }
            if (parseInt(diaUno) >= parseInt(diaDos)) {
                return true;
            } else return false;
        },


        calculoAporteReducido(fecafil) {
            if (this.calcularEdad(fecafil) < 35) {
                if (this.calcularEdad(this.dataSelected.fecmat) > 31) {
                    console.log('RAR')
                    this.getOpcionNivel()
                }
                console.log('PJ')
                this.getOpcionNivel()
                //this.addItemNivel({ id: 6, desc: 'PJ' },)
            }
            else {
                console.log('RAR')
                this.getOpcionNivel()
                //this.addItemNivel({ id: 7, desc: 'RAR' })
            }
            // this.nextStep()
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        guardar() {
            //const fechasOk = this.validarFechas(today)
            //this.calculoAporteReducido((new Date()).toJSON().slice(0, 10))
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.guardarDatosProfesionales(this.dataSelected)
                    this.$emit('siguiente')
                    this.getOpcionNivel()
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            })
        }
    },
}

</script>
